<template>
	<div>
		<preloader v-if="loading"></preloader>
		<div class="d-flex justify-content-between">
			<button class="btn btn-primary mb-3 btn-sm" v-on:click="getCobrosRealizados">
				<i class="material-icons">refresh</i>
			</button>
		</div>
		<div class="table-responsive" v-if="cobros.length>0">
			<table class="table table-sm table-bordered">
				<thead>
					<tr>
						<th width="50px">Cobro</th>
						<th width="50px">Código</th>
						<th width="80px">Fecha</th>
						<th width="80px">Pago</th>
						<th width="7%">Capital</th>
						<th width="7%">Interés</th>
						<th width="7%">Seguro</th>
						<th width="7%">GPS</th>
						<th width="7%">Otros</th>
						<th width="7%">Mora interés</th>
						<th width="7%">Mora servicios</th>
						<th width="7%">Total</th>
						<th>Observaciones</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="cobro in cobros" :class="{'cursor-pointer':true, 'bg-gray-light text-muted':cobro.TOTAL_MONTO==0,'opacity-70':cobro.TOTAL_MONTO<=0,'table-danger':cobro.TOTAL_MONTO<0}">
						<th v-text="cobro.CODIGO_COBRO"></th>
						<th v-text="cobro.CORRELATIVO_COBRO"></th>
						<td class="text-center">
							<span class="badge badge-dark">
								{{cobro.FECHA_PAGADO}}
							</span>
						</td>
						<td>{{cobro.medio_pago ? cobro.medio_pago.DESCRIPCION_FORMA_PAGO : 'No definido'}}</td>
						<td v-bind:class="{'text-right':true,'font-weight-bold text-danger':cobro.MONTO_CAPITAL<0}">
							{{cobro.MONTO_CAPITAL | money}}
						</td>
						<td v-bind:class="{'text-right':true,'font-weight-bold text-danger':cobro.MONTO_INTERES<0}">
							{{cobro.MONTO_INTERES | money}}
						</td>
						<td v-bind:class="{'text-right':true,'font-weight-bold text-danger':cobro.MONTO_SEGURO<0}">
							{{cobro.MONTO_SEGURO | money}}
						</td>
						<td v-bind:class="{'text-right':true,'font-weight-bold text-danger':cobro.MONTO_GPS<0}">
							{{cobro.MONTO_GPS | money}}
						</td>
						<td v-bind:class="{'text-right':true,'font-weight-bold text-danger':cobro.MONTO_OTROS<0}">
							{{cobro.MONTO_OTROS | money}}
						</td>
						<td v-bind:class="{'text-right':true,'font-weight-bold text-danger':cobro.MONTO_MORA_INT<0}">
							{{cobro.MONTO_MORA_INT | money}}
						</td>
						<td v-bind:class="{'text-right':true,'font-weight-bold text-danger':cobro.MONTO_SERVICIOS<0}">
							{{cobro.MONTO_SERVICIOS | money}}
						</td>
						<td v-bind:class="{'text-right':true,'font-weight-bold text-danger':cobro.TOTAL_SALDO<0}">
							{{cobro.TOTAL_SALDO | money}}
						</td>
						<td v-text="cobro.OBSERVACIONES_COBRO"></td>
					</tr>
					<tr>
						<th colspan="4">Totales</th>
						<th v-bind:class="{'text-right':true}">
							{{getTotal('MONTO_CAPITAL') | money}}
						</th>
						<th v-bind:class="{'text-right':true}">
							{{getTotal('MONTO_INTERES') | money}}
						</th>
						<th v-bind:class="{'text-right':true}">
							{{getTotal('MONTO_SEGURO') | money}}
						</th>
						<th v-bind:class="{'text-right':true}">
							{{getTotal('MONTO_GPS') | money}}
						</th>
						<th v-bind:class="{'text-right':true}">
							{{getTotal('MONTO_OTROS') | money}}
						</th>
						<th v-bind:class="{'text-right':true}">
							{{getTotal('MONTO_MORA_INT') | money}}
						</th>
						<th v-bind:class="{'text-right':true}">
							{{getTotal('MONTO_SERVICIOS') | money}}
						</th>
						<th v-bind:class="{'text-right':true}">
							{{getTotal('TOTAL_SALDO') | money}}
						</th>
						<th></th>
					</tr>
				</tbody>
			</table>
		</div>
		<div v-else>
	    	<empty icon="hourglass_empty" title="No hay información." description="No hay información relacionada a los cobros programados.">
	        </empty>
	    </div>
	</div>
</template>
<script>
	export default {
		props: ['codigo', 'disabled'],

		data(){
			return {
				cobros: [],
				loading: false,

				modalProgramado: 'create',
				realizado: {
					endoso: '',
					cobro: '',
					fecha_pago: '',
					medio_pago: '',
					monto: '',
					factura: '',
					observaciones: '',
					monto_capital: '',
					monto_interes: '',
					monto_seguro: '',
					monto_gps: '',
					monto_otros: '',
					monto_mora_int: '',
					monto_mora_servicios: '',
					is_automatic: '',
				},
				errors: {},
				compacta: false,
			}
		},

		mounted(){
			this.getCobrosRealizados();
			var vm = this;
			$.fn.getCobrosRealizados = function (options) {
				vm.getCobrosRealizados();
			};
		},

		methods: {
			getTotal(index){
				var total = [];

				Object.entries(this.cobros).forEach(([key, val]) => {
					total.push(val[index]);
				});
				
				return total.reduce(function(tot, num){
					return parseFloat(tot || 0) + parseFloat(num || 0);
				}, 0);
				//return this.cobros.reduce((a, b) => a + (b[index] || 0), 0)
			},

			getCobrosRealizados(){
				this.loading = true
				axios.get(`api/prestamos/${this.codigoDF}/cobros/realizados`).then(res => {
					this.cobros = res.data
				}).catch(err => {
					console.log(err.response)
				}).then(()=>{
					this.loading = false
				})
			},
		},

		computed: {
			codigoDF(){
				return this.codigo
			},

			disabledValue: function(){
        		return this.disabled
        	},
		}
	}
</script>